import { React, useContext } from "react";
import { Grid } from 'antd-mobile';
import { useNavigate } from "react-router-dom"
import { page, IsDev } from 'utils/constant';
import { UserContext } from "utils/getContext";
import {
  recruitweb, emService, marketInquiryIcon,
  publicInstitutionRecruitment, bysEmp, empWorkService
} from "utils/getImg";
import 'static/css/serviceArea.css'

const shopData = [
  // {
  //   id: 6,
  //   src: bysEmp,
  //   title: '毕业生求职招聘',
  //   goal: 'bys'
  // },
  {
    id: 1,
    src: recruitweb,
    title: '求职招聘',
    goal: 'https://www.fj99.org.cn/job/'
  },
  {
    id: 4,
    src: publicInstitutionRecruitment,
    title: '事业单位公开招聘',
    goal: 'http://220.160.53.33:8903/home'
  },
  {
    id: 8,
    src: empWorkService,
    title: '办事服务',
    goal: page.Work
  }
]

const orgData = [
  {
    id: 2,
    src: emService,
    title: '就业服务机构',
    goal: page.SHOP
  },
  {
    id: 3,
    src: marketInquiryIcon,
    title: '零工市场机构',
    goal: page.MARKET
  }
]

/** 服务专区 */
export function ServiceArea({ type }) {
  const navigate = useNavigate()
  const { loginInfo } = useContext(UserContext)
  // 测试环境多最后一个数据
  const newShowData = IsDev ? shopData : shopData.slice(0, shopData.length - 1)
  const data = type === 'org' ? orgData : newShowData

  function handleShopClick(goal) {
    if (goal) {
      if (goal.startsWith('http')) {
        window.location.href = goal
      } else {
        if (goal === 'bys') {
          if (loginInfo?.bysjyAppUrl) {
            window.location.href = loginInfo?.bysjyAppUrl
          }
        } else {
          navigate(goal)
        }
      }
    }
  }

  return (
    <Grid columns={2} gap={12}>
      {
        data.map(item =>
          <div className="ServiceAreaContent" key={item.id} onClick={() => handleShopClick(item.goal)}>
            <img src={item.src} alt={item.title}></img>
            <div className='ServiceAreaText'>{item.title}</div>
            <div className='ServiceAreaText-con'>快速跳转至{item.title}</div>
          </div>
        )
      }
    </Grid >

  )
}